<button
  data-at-icon-button
  mat-icon-button
  class="vi-icon-button"
  [class.opacity]="opacity"
  [color]="color"
>
  <mat-icon><ng-content></ng-content></mat-icon>
</button>
